export default __webpack_public_path__ + "assets/images/dbd617ca2de9e99482040a99ff19c4b6.png";